import React from 'react'
import Calendar from '../../admin/layout/Calendar/Calendar'
import Select from '../../admin/layout/Select'
import axios from "axios/index"

export default class CalendarLayout extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            pl_id: null,
            plg_id: null,
            locations: this.props.locations,
            groups: [],
            offers: {requests: [], specials: []},
            loading_locations: false,
            loading_groups: false,
            loading_offers: false
        }
    }


    selectLocation = (pl_id) => {
        this.setState({pl_id: pl_id, loading_groups: !!pl_id, plg_id: null, groups: [], offers: []})
        if (!pl_id) return
        axios.get(`/dashboard/rental_calendars/groups.json?provider_location_id=${pl_id}`)
            .then(res => this.setState({...res.data, loading_groups: false}))
    }


    selectGroup = (plg_id) => {
        this.setState({plg_id: plg_id, loading_offers: !!plg_id, offers: []})
        if (!plg_id) return
        axios.get(`/dashboard/rental_calendars/offers.json?provider_location_group_id=${plg_id}`)
            .then(res => this.setState({...res.data, loading_offers: false}))
    }

    componentDidMount = () => {
        // this.selectGroup(21)
    }

    render() {
        return (
            <div>
                <div className={'row'}>
                    <div className={'col-sm-6 col-md-4 mb-3'}>
                        <Select carModels={this.state.locations} handleChange={this.selectLocation}/>
                    </div>
                    <div className={'col-sm-6 col-md-4 mb-3'}>
                        {this.state.pl_id && !this.state.loading_groups && !this.state.loading_locations &&
                        <Select carModels={this.state.groups} handleChange={this.selectGroup}/>
                        }
                    </div>
                    {this.state.pl_id &&
                    <div className={'col-md-4 mb-3 py-1'}>
                        <a href={`/dashboard/rental_offers?pl_id=${this.state.pl_id}`}>Vezi ca tabel</a>
                    </div>
                    }
                </div>
                {this.state.plg_id && !this.state.loading_groups && !this.state.loading_locations && !this.state.loading_offers &&
                <Calendar
                    offers={this.state.offers}
                    plg_id={this.state.plg_id}
                    reload={() => this.selectGroup(this.state.plg_id)}
                    baseUrl={'/dashboard'}
                />
                }
            </div>
        )
    }
}